import React from "react";
import {observer} from "mobx-react-lite";
import EditField from "../../molecules/editField/editField";
import {ObservableList} from "../../../stores/observables/observableList";
import {KeyValue} from "../../../stores/observables/keyValue";
import DropdownInput from "../../atoms/input/dropdownInput";

export interface ISelectEditProps {
  value: ObservableList<KeyValue>;
  onChange?: (value: KeyValue) => void;
  label: string;
  validationMessage?: string;
  placeholder?: string;
  isLoading?: boolean;
  isDisabled?: boolean;
  isRequired?: boolean;
}

const Selection: React.FC<ISelectEditProps> = ({
  value,
  label,
  onChange,
  validationMessage,
  placeholder,
  isLoading,
  isDisabled,
  isRequired = true
}) => {
  return (
    <EditField label={label} isRequired={value.validate != null && isRequired}>
      <DropdownInput
        value={value}
        errorText={validationMessage}
        placeholder={placeholder}
        isLoading={isLoading}
        disabled={isDisabled}
        onChange={onChange}
      />
    </EditField>
  );
};

export default observer(Selection);
